export default function (props: any) {
    return (
        <svg {...props} width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <circle id="path-1" cx="20" cy="20" r="20"></circle>
            </defs>
            <g id="MM100众筹" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="WEB-/--Bundles-tab" transform="translate(-1555.000000, -1760.000000)">
                    <g id="计算器" transform="translate(1555.000000, 1760.000000)">
                        <mask id="mask-2" fill="white">
                            <use xlinkHref="#path-1"></use>
                        </mask>
                        <g id="path-1"></g>
                        <g id="编组" mask="url(#mask-2)">
                            <g transform="translate(7.272727, 7.272727)">
                                <rect id="矩形" x="0" y="0" width="25.4545455" height="25.4545455"></rect>
                                <g id="编组-25" strokeWidth="1" fillRule="evenodd" transform="translate(5.139860, 2.937063)">
                                    <rect
                                        id="矩形"
                                        stroke="#FFFFFF"
                                        strokeWidth="0.72"
                                        x="0"
                                        y="0"
                                        width="15.1748252"
                                        height="19.5804196"
                                        rx="2.17549367"
                                    ></rect>
                                    <g id="编组-7" transform="translate(2.744091, 2.662116)" fill="#FFFFFF" stroke="#FFFFFF" strokeWidth="0.72">
                                        <rect id="矩形" x="4.54747351e-13" y="0" width="9.68664244" height="2.72035003" rx="0.435098734"></rect>
                                        <rect id="矩形" x="0" y="5.32423247" width="1.45436842" height="1.38929191" rx="0.435098734"></rect>
                                        <rect id="矩形备份-16" x="0" y="8.87372076" width="1.45436842" height="1.38929191" rx="0.435098734"></rect>
                                        <rect id="矩形备份-19" x="0" y="12.4232092" width="1.45436842" height="1.38929191" rx="0.435098734"></rect>
                                        <rect id="矩形备份-14" x="4.11613701" y="5.32423247" width="1.45436842" height="1.38929191" rx="0.435098734"></rect>
                                        <rect id="矩形备份-17" x="4.11613701" y="8.87372076" width="1.45436842" height="1.38929191" rx="0.435098734"></rect>
                                        <rect id="矩形备份-20" x="4.11613701" y="12.4232092" width="1.45436842" height="1.38929191" rx="0.435098734"></rect>
                                        <rect id="矩形备份-15" x="8.23227405" y="5.32423247" width="1.45436842" height="1.38929191" rx="0.435098734"></rect>
                                        <rect id="矩形备份-21" x="8.23227405" y="8.87372076" width="1.45436842" height="4.93878024" rx="0.435098734"></rect>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
